var $6a984000f9068c66$exports = {};
$6a984000f9068c66$exports = {
    "loading": `Notiek iel\u{101}de...`,
    "loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`
};


export {$6a984000f9068c66$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
